module.exports = __webpack_public_path__ + "media/images/icons/large-arrow-down-b73057b0d2f25c971d10beeaebed4b3b.svg";